<!-- <section class="head">

</section> -->

<section class="body">
    <!--módulos-->
    <div class="container-applications__section row col-xxs-12">
        <h2 class="container-applications__title">
            {{ "integrations.modules" | translate }}
        </h2>

        <div class="container-applications__list">
            <!-- AI Module Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    [class.block-provider--disabled]="
                        !company?.permissions?.companyAiAssistant
                    "
                    (click)="isAiModuleEnabled() && openAiModuleSettings()"
                >
                    <li
                        class="block-provider__card card-app-list ai-module-card"
                        [class.ai-module-card--disabled]="
                            !company?.permissions?.companyAiAssistant
                        "
                    >
                        <!-- Status Badge -->
                        <div
                            class="ai-module-card__badge"
                            *ngIf="!company?.permissions?.companyAiAssistant"
                        >
                            <span class="badge-text">{{
                                "words.disabled" | translate
                            }}</span>
                        </div>

                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-bulb text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>{{ "words.ai-assistant" | translate }}</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>
                                {{
                                    "integrations.ai-module-description"
                                        | translate
                                }}
                            </p>
                        </div>

                        <!-- Footer with status -->
                        <div class="ai-module-card__footer">
                            <span
                                class="ai-module-card__status"
                                *ngIf="company?.permissions?.companyAiAssistant"
                            >
                                {{ "integrations.configured" | translate }}
                            </span>
                            <span
                                class="ai-module-card__status ai-module-card__status--disabled"
                                *ngIf="
                                    !company?.permissions?.companyAiAssistant
                                "
                            >
                                {{ "integrations.not-available" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Client API Docs Card (todos los administradores) -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul class="block-provider" (click)="openClientApiDocs()">
                    <li class="block-provider__card card-app-list ai-module-card">
                        <div class="ai-module-card__icon">
                            <i class="icon icon-code text-primary-500"></i>
                        </div>

                        <div class="ai-module-card__title">
                            <p>{{ "client-api-docs.title" | translate }}</p>
                        </div>

                        <div class="ai-module-card__description">
                            <p>{{ "client-api-docs.card-description" | translate }}</p>
                        </div>

                        <div class="ai-module-card__footer">
                            <span class="ai-module-card__status">
                                {{ "client-api-docs.open" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Payment Gateway Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    style="cursor: pointer"
                    (click)="openPaymentGateway()"
                >
                    <li class="block-provider__card card-app-list ai-module-card">
                        <div class="ai-module-card__icon">
                            <i class="icon icon-lock text-primary-500"></i>
                        </div>
                        <div class="ai-module-card__title">
                            <p>{{ "payment-gateway.module-title" | translate }}</p>
                        </div>
                        <div class="ai-module-card__description">
                            <p>{{ "payment-gateway.module-description" | translate }}</p>
                        </div>
                        <div class="ai-module-card__footer">
                            <span class="ai-module-card__status">
                                {{ "integrations.configure" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Subscriptions Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    style="cursor: pointer"
                    (click)="openSubscriptions()"
                >
                    <li class="block-provider__card card-app-list ai-module-card">
                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-credit-card text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>{{ "subscriptions.module-title" | translate }}</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>{{ "subscriptions.module-description" | translate }}</p>
                        </div>

                        <!-- Footer -->
                        <div class="ai-module-card__footer">
                            <span class="ai-module-card__status">
                                {{ "integrations.configured" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Public Catalogue Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    [style.opacity]="publicCatalogueEnabled === false ? '0.6' : '1'"
                    [style.cursor]="publicCatalogueEnabled === false ? 'not-allowed' : 'pointer'"
                    (click)="openPublicCatalogue()"
                >
                
                    <li
                        class="block-provider__card card-app-list ai-module-card"
                        [class.ai-module-card--disabled]="publicCatalogueEnabled === false"
                    >
                        <!-- Status Badge -->
                        <div
                            class="ai-module-card__badge"
                            *ngIf="publicCatalogueEnabled === false"
                        >
                            <span class="badge-text">{{
                                "words.disabled" | translate
                            }}</span>
                        </div>

                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-catalogue text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>{{ "integrations.public-catalogue" | translate }}</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>{{
                                "integrations.public-catalogue-description"
                                    | translate
                            }}</p>
                        </div>

                        <!-- Footer with status -->
                        <div class="ai-module-card__footer">
                            <span
                                class="ai-module-card__status"
                                *ngIf="publicCatalogueEnabled === true"
                            >
                                {{ "integrations.configured" | translate }}
                            </span>
                            <span
                                class="ai-module-card__status ai-module-card__status--disabled"
                                *ngIf="publicCatalogueEnabled === false"
                            >
                                {{ "words.disabled" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Portal Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    [style.opacity]="portalEnabled === false ? '0.6' : '1'"
                    style="cursor: pointer"
                    (click)="isPortalEnabled() && openPortal()"
                >
                    <li
                        class="block-provider__card card-app-list ai-module-card"
                        [class.ai-module-card--disabled]="portalEnabled === false"
                    >
                        <!-- Status Badge -->
                        <div
                            class="ai-module-card__badge"
                            *ngIf="portalEnabled === false"
                        >
                            <span class="badge-text">{{
                                "words.disabled" | translate
                            }}</span>
                        </div>

                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-globe text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>{{ "integrations.portal" | translate }}</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>{{
                                "integrations.portal-description"
                                    | translate
                            }}</p>
                        </div>

                        <!-- Footer with status -->
                        <div class="ai-module-card__footer">
                            <span
                                class="ai-module-card__status"
                                *ngIf="portalEnabled === true"
                            >
                                {{ "integrations.configured" | translate }}
                            </span>
                            <span
                                class="ai-module-card__status ai-module-card__status--disabled"
                                *ngIf="portalEnabled === false"
                            >
                                {{ "words.disabled" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Griky Skills Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    [class.block-provider--disabled]="!isGrikySkillsEnabled()"
                    (click)="isGrikySkillsEnabled() && openGrikySkillsSettings()"
                >
                    <li
                        class="block-provider__card card-app-list ai-module-card"
                        [class.ai-module-card--disabled]="!isGrikySkillsEnabled()"
                    >
                        <!-- Status Badge -->
                        <div class="ai-module-card__badge" *ngIf="!isGrikySkillsEnabled()">
                            <span class="badge-text">{{ "words.disabled" | translate }}</span>
                        </div>

                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-star text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>{{ "griky-skills.module-title" | translate }}</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>{{ "griky-skills.module-description" | translate }}</p>
                        </div>

                        <!-- Footer -->
                        <div class="ai-module-card__footer">
                            <span
                                class="ai-module-card__status"
                                *ngIf="isGrikySkillsEnabled()"
                            >
                                {{ "integrations.configure" | translate }}
                            </span>
                            <span
                                class="ai-module-card__status ai-module-card__status--disabled"
                                *ngIf="!isGrikySkillsEnabled()"
                            >
                                {{ "integrations.not-available" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Academic Profile Card -->
            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider"
                    [class.block-provider--disabled]="!isAcademicProfileEnabled()"
                    (click)="isAcademicProfileEnabled() && openAcademicProfileSettings()"
                >
                    <li
                        class="block-provider__card card-app-list ai-module-card"
                        [class.ai-module-card--disabled]="!isAcademicProfileEnabled()"
                    >
                        <!-- Status Badge -->
                        <div class="ai-module-card__badge" *ngIf="!isAcademicProfileEnabled()">
                            <span class="badge-text">{{ "words.disabled" | translate }}</span>
                        </div>

                        <!-- Icon -->
                        <div class="ai-module-card__icon">
                            <i class="icon icon-book-open text-primary-500"></i>
                        </div>

                        <!-- Title -->
                        <div class="ai-module-card__title">
                            <p>Perfil Académico</p>
                        </div>

                        <!-- Description -->
                        <div class="ai-module-card__description">
                            <p>Activa o desactiva el perfil académico de los learners de tu empresa</p>
                        </div>

                        <!-- Footer -->
                        <div class="ai-module-card__footer">
                            <span class="ai-module-card__status"
                                *ngIf="isAcademicProfileEnabled()">
                                {{ "integrations.configured" | translate }}
                            </span>
                            <span
                                class="ai-module-card__status ai-module-card__status--disabled"
                                *ngIf="!isAcademicProfileEnabled()">
                                {{ "integrations.not-available" | translate }}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="container-applications__section row col-xxs-12">
        <h2 class="container-applications__title">
            {{ "integrations.company-links" | translate }}
        </h2>

        <!--vinculos a empresas-->
        <div class="container-applications__list">
            <div
                class="container-applications__item col-3 col-md-3 col-xxs-12"
                *ngFor="let link of externalLinks; let index = index"
            >
                <ul class="block-provider block-provider--link">
                    <li class="block-provider__card card-app-list link-card">
                        <!-- Icon in top left corner -->
                        <div class="link-card__icon-top">
                            <i
                                class="icon icon-globe text-secondary-500"
                                *ngIf="link.type === 'lti'"
                            ></i>
                            <i
                                class="icon icon-link-2 text-secondary-500"
                                *ngIf="link.type === 'url'"
                            ></i>
                        </div>

                        <!-- Actions in top right corner -->
                        <div class="link-card__actions-top">
                            <div
                                class="dropdown-actions"
                                [ngClass]="{
                                    active: displayDropdowns.link[index]
                                }"
                                [(autoClose)]="displayDropdowns.link[index]"
                            >
                                <div
                                    class="dropdown-actions__selected"
                                    (click)="displayed('link', index)"
                                >
                                    <i class="icon icon-more-horizontal"></i>
                                </div>
                                <div class="dropdown-actions__content">
                                    <ul class="dropdown-actions__list">
                                        <li
                                            class="dropdown-actions__item"
                                            (click)="
                                                integrationLinkAside.onOpen(
                                                    link.type,
                                                    link
                                                )
                                            "
                                        >
                                            <a>
                                                <i class="icon icon-edit"></i>
                                                {{ "words.edit" | translate }}
                                            </a>
                                        </li>
                                        <li
                                            class="dropdown-actions__item dropdown-actions__item--trash"
                                            (click)="
                                                manageDeleteLink(link, index)
                                            "
                                        >
                                            <a>
                                                <i class="icon icon-trash"></i>
                                                {{ "words.delete" | translate }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Image Section -->
                        <div class="link-card__image-wrapper">
                            <img
                                class="link-card__image"
                                [src]="
                                    link.picture
                                        ? link.picture + '?size=256'
                                        : decrypt + link.url
                                "
                                [alt]="link.name"
                                loading="lazy"
                            />
                            <div class="link-card__image-overlay"></div>
                        </div>

                        <!-- Title Section -->
                        <div class="link-card__footer">
                            <p class="link-card__name">
                                {{ link.name | truncate: 30 }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider block-provider--selectable block-provider--link"
                    (click)="integrationLinkAside.onOpen('url')"
                >
                    <li
                        class="block-provider__card card-app-list link-card link-card--add"
                    >
                        <div class="link-card__add-content">
                            <i class="icon icon-link-2 text-secondary-500"></i>
                            <p>{{ "integrations.add-link" | translate }}</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider block-provider--selectable block-provider--link"
                    (click)="integrationLinkAside.onOpen('lti')"
                >
                    <li
                        class="block-provider__card card-app-list link-card link-card--add"
                    >
                        <div class="link-card__add-content">
                            <i class="icon icon-globe text-secondary-500"></i>
                            <p>{{ "integrations.lti-tools" | translate }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!--lista de reproduccion-->
    <div
        class="container-applications__section row col-xxs-12"
        *ngIf="isPlaylistEnabled()"
    >
        <h2 class="container-applications__title">
            {{ "integrations.playlist" | translate }}
        </h2>

        <div class="container-applications__list">
            <div
                class="container-applications__item col-3 col-md-3 col-xxs-12"
                *ngFor="let playlist of playlists; let index = index"
            >
                <ul class="block-provider block-provider--playlist">
                    <li class="block-provider__card playlist-card">
                        <!-- Header with sync info and actions -->
                        <div class="playlist-card__header">
                            <div
                                class="playlist-card__sync-info"
                                *ngIf="playlist.lastSync"
                            >
                                <i
                                    class="icon icon-refresh text-secondary-500"
                                ></i>
                                <span class="playlist-card__sync-date">{{
                                    playlist.lastSync | date: "dd/MM/YYYY"
                                }}</span>
                            </div>
                            <div class="playlist-card__actions">
                                <div
                                    class="dropdown-actions"
                                    [ngClass]="{
                                        active: displayDropdowns.playlist[index]
                                    }"
                                    [(autoClose)]="
                                        displayDropdowns.playlist[index]
                                    "
                                >
                                    <div
                                        class="dropdown-actions__selected"
                                        (click)="displayed('playlist', index)"
                                    >
                                        <i
                                            class="icon icon-more-horizontal"
                                        ></i>
                                    </div>
                                    <div class="dropdown-actions__content">
                                        <ul class="dropdown-actions__list">
                                            <li
                                                class="dropdown-actions__item"
                                                (click)="
                                                    playlistAside.onOpen(
                                                        playlist
                                                    )
                                                "
                                            >
                                                <a>
                                                    <i
                                                        class="icon icon-edit"
                                                    ></i>
                                                    {{
                                                        "words.edit" | translate
                                                    }}
                                                </a>
                                            </li>
                                            <li
                                                class="dropdown-actions__item"
                                                (click)="
                                                    refreshPlaylist(
                                                        playlist,
                                                        index
                                                    )
                                                "
                                            >
                                                <a>
                                                    <i
                                                        class="icon icon-refresh"
                                                    ></i>
                                                    {{
                                                        "words.refresh"
                                                            | translate
                                                    }}
                                                </a>
                                            </li>
                                            <li
                                                class="dropdown-actions__item dropdown-actions__item--trash"
                                                (click)="
                                                    deletePlaylist(
                                                        playlist,
                                                        index
                                                    )
                                                "
                                            >
                                                <a>
                                                    <i
                                                        class="icon icon-trash"
                                                    ></i>
                                                    {{
                                                        "words.delete"
                                                            | translate
                                                    }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Image/Status Section -->
                        <div class="playlist-card__image-wrapper">
                            <div
                                *ngIf="!playlist.status || !playlist.mediaUrl"
                                class="playlist-card__placeholder"
                            >
                                <i
                                    class="icon icon-clock text-secondary-500"
                                ></i>
                                <span *ngIf="!playlist.status">{{
                                    "words.loading" | translate
                                }}</span>
                            </div>
                            <img
                                *ngIf="playlist.mediaUrl && playlist.status"
                                class="playlist-card__image"
                                [src]="playlist.mediaUrl"
                                [alt]="playlist.name"
                                loading="lazy"
                            />
                            <div class="playlist-card__image-overlay"></div>
                        </div>

                        <!-- Title Section -->
                        <div class="playlist-card__footer">
                            <p class="playlist-card__name">
                                {{ playlist.name | truncate: 30 }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="container-applications__item col-3 col-md-3 col-xxs-12">
                <ul
                    class="block-provider block-provider--selectable block-provider--link"
                    (click)="playlistAside.onOpen()"
                >
                    <li
                        class="block-provider__card playlist-card playlist-card--add"
                    >
                        <div class="playlist-card__add-content">
                            <i class="icon icon-list text-secondary-500"></i>
                            <p>{{ "integrations.add-playlist" | translate }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!--aplicaciones-->
    <div
        class="container-applications__section row col-xxs-12"
        *ngIf="connectedApplications.length > 0"
    >
        <h2 class="container-applications__title">
            {{ "integrations.app-connected" | translate }}
        </h2>

        <div class="container-applications__list">
            <div
                class="container-applications__item col-3 col-md-3 col-xxs-12"
                *ngFor="let application of connectedApplications"
            >
                <ul
                    class="block-provider"
                    *ngFor="let feature of application.features"
                    (click)="
                        editFeature(application, feature);
                        freshChatAside.onOpen()
                    "
                    [ngClass]="{
                        'block-provider--editable':
                            application.name === 'freshchat'
                    }"
                >
                    <li
                        class="block-provider__card card-app-list justify-around gap-2"
                    >
                        <div
                            class="block-provider__card__picture"
                            [style.backgroundImage]="
                                'url(https://static.myskillcamp.com/images/integrations/' +
                                application.name +
                                '.svg)'
                            "
                        ></div>

                        <div
                            class="block-provider__incoming d-flex w-60 justify-center"
                            *ngIf="application.isConnectable"
                        >
                            <msc-button
                                class="msc-button--primary w-60"
                                palette="secondary"
                                (click)="
                                    unlinkApplication(application);
                                    stopPropagation($event)
                                "
                            >
                                {{ "integrations.unlink" | translate }}
                            </msc-button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!--provedores-->
    <!--provedores
    <div class="container-applications__section row col-xxs-12" *ngIf="displayedAvailableApplications.length > 0">
        <h2 class="container-applications__title">
            {{ 'integrations.content-providers' | translate }}
        </h2>

        <div class="container-applications__list">
            <div class="container-applications__item col-3 col-md-3 col-xxs-12" style="position:relative;  z-index: 0;"
                *ngFor="let application of displayedAvailableApplications">
                    <div class="badge"> {{ 'words.coming-soon' | translate }} </div>
                <ul class="block-provider">
                    <li class="block-provider__card card-app-list justify-around gap-2">
                        <div class="block-provider__card__picture"
                            [style.backgroundImage]="'url(https://static.myskillcamp.com/images/integrations/' + application.name + '.svg)'">
                        </div>

                        <div class="block-provider__incoming d-flex w-60 justify-center">
                            <msc-button class="msc-button--primary w-60" palette="primary"
                                (click)="linkApplication(application)" *ngIf="application.isConnectable">
                                {{ 'integrations.link' | translate }}
                            </msc-button>

                            <msc-button class="msc-button--primary w-60" palette="secondary" (click)="contact()"
                                *ngIf="!application.isConnectable">
                                {{ 'words.contact-us' | translate }}
                            </msc-button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>-->
    <!--crms-->
    <div
        *ngIf="release.crm"
        class="container-applications__section row col-xxs-12"
    >
        <h2 class="container-applications__title">
            {{ "integrations.crm-integrations" | translate }}
        </h2>

        <div class="container-applications__list">
            <div
                class="container-applications__item col-3 col-md-3 col-xxs-12"
                style="position: relative; z-index: 0"
                *ngFor="let application of comingSoonApplications"
            >
                <div class="badge">{{ "words.coming-soon" | translate }}</div>
                <ul class="block-provider">
                    <li class="block-provider__card card-app-list crm-card">
                        <!-- Logo Section -->
                        <div class="crm-card__logo-container">
                            <img
                                class="crm-card__logo"
                                [src]="getApplicationLogoPath(application.name)"
                                [alt]="application.label"
                            />
                        </div>

                        <!-- Title Section -->
                        <div class="crm-card__title-section">
                            <p class="crm-card__title">
                                {{ application.label }}
                            </p>
                        </div>

                        <!-- Button Section -->
                        <div class="crm-card__button-section">
                            <msc-button
                                [disabled]="true"
                                style="pointer-events: none"
                                class="msc-button--primary w-60 disabled"
                                palette="primary"
                                (click)="linkApplication(application)"
                                *ngIf="application.isConnectable"
                                disabled
                            >
                                {{ "integrations.link" | translate }}
                            </msc-button>

                            <msc-button
                                [disabled]="true"
                                style="pointer-events: none"
                                class="msc-button--primary w-60 disabled"
                                palette="primary"
                                (click)="contact()"
                                *ngIf="!application.isConnectable"
                                disabled
                            >
                                {{ "words.contact-us" | translate }}
                            </msc-button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<msc-shared-aside-integration-link
    #integrationLinkAside
    (onSave)="manageLink($event)"
>
</msc-shared-aside-integration-link>

<msc-shared-aside-integration-playlist
    #playlistAside
    [manage]="true"
    [companyId]="company.id"
    (onSave)="managePlaylist($event)"
>
</msc-shared-aside-integration-playlist>

<msc-organize-integration-aside-freshchat
    #freshChatAside
    [freshchat]="selected.application"
    [companyId]="company.id"
    (onSave)="manageApplication($event)"
>
</msc-organize-integration-aside-freshchat>

<!-- AI Module Settings Modal -->
<msc-common-modal
    #aiModuleModal
    size="70vw"
    [title]="'words.ai-assistant' | translate"
>
    <ng-template>
        <div style="max-height: 65vh; overflow-y: auto; padding-right: 4px">
            <app-ai-settings [companyId]="company.id"></app-ai-settings>
        </div>
        <div class="flex items-center justify-end mt-4">
            <msc-button
                class="msc-button--primary"
                palette="primary"
                (click)="closeAiModuleSettings()"
            >
                {{ "common.close" | translate }}
            </msc-button>
        </div>
    </ng-template>
</msc-common-modal>

<msc-common-modal
    size="30vw"
    #modalDeleteLink
    [title]="'words.confirm-action' | translate"
>
    <ng-template>
        <p *ngIf="selected?.link?.name">
            {{ "lti.modal.delete" | translate: { name: selected.link.name } }}
        </p>
        <div class="flex items-center mt-5 space-x-5 justify-end">
            <msc-button
                class=""
                palette="primary"
                (click)="modalDeleteLink.onClose()"
                >{{ "common.cancel" | translate }}</msc-button
            >
            <msc-button
                class="msc-button--primary w-60"
                palette="primary"
                (click)="deleteLink(selected.link); modalDeleteLink.onClose()"
                >{{ "common.save" | translate }}</msc-button
            >
        </div>
    </ng-template>
</msc-common-modal>
